import script from "./InviteMemberTagsInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./InviteMemberTagsInput.vue?vue&type=script&setup=true&lang=ts"

import "./InviteMemberTagsInput.vue?vue&type=style&index=0&id=62aa0d90&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62aa0d90"]])

export default __exports__